export default {
  data() {
    return {
      isShow: false,
      contentIsShow: false,
      showAnimate: "animated fadeInDown",
      contentAnimate: 'animated fadeInUp',
      _scrollTop: 0,
      marginTop: 100,
      contentTop: 200,
    };
  },
  computed: {
    titleAnimation() {
      if (this.isShow) {
        return this.showAnimate;
      }
      return 'invisible'
    },
    contentAnimation() {
      if (this.contentIsShow) {
        return this.contentAnimate;
      }
      return 'invisible'
    },
    scrollTop: {
      get() {
        return this._scrollTop;
      },
      set(val) {
        const offsetTop = this.$el.offsetTop + this.marginTop;
        const innerHeight = window.innerHeight;
        if (val + innerHeight - offsetTop > 0) {
          this.setAnimate();
        }
        if (val + innerHeight - offsetTop - this.contentTop > 0) {
          this.setContentAnimate();
        }
        this._scrollTop = val;
      },
    },
  },
  methods: {
    setAnimate() {
      this.isShow = true;
    },
    setContentAnimate() {
      this.contentIsShow = true;
    },
  },
  mounted() {
    window.addEventListener('scroll', () => {
      this.scrollTop = window.scrollY || window.pageYOffset;
    })
    this.scrollTop = window.scrollY || window.pageYOffset;
  },
};
